/**
 * Translation key for a regeneration failure code from the API
 * (`wave_info_error`). Unknown codes fall back to a generic message, so a
 * new backend code never shows raw text to an editor.
 */
const KNOWN_CODES = new Set([
  'source_not_found',
  'source_unreadable',
  'source_blocked',
  'session_unavailable',
  'timed_out',
  'queue_unavailable'
]);

export const waveInfoErrorKey = (code: string | null | undefined): string =>
  code && KNOWN_CODES.has(code)
    ? `wave-info-error-${code}`
    : 'wave-info-regeneration-failed-notice';
